(function () {
    'use strict';
    angular.module('vcuser.vcuser')
        .component('usersearch', {
            restrict: 'E',
            bindings: {
                user: '<',
                userref: '<',
                parentsave: '&?',
                editinplace: '@?',
                ti: '@?'
            },
            template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   placeholder="Benutzer"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showuser($item, $model, $label)"
                   uib-typeahead="user as user.text for user in vm.getUsers($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-refresh"></i>
        <div ng-show="noResults">
          <i class="fa fa-remove"></i> Keinen User gefunden
          <span class="btn btn-success" ng-click="vm.addUser()" ng-hide="vm.error">Neuen User eingeben</span>
          <span ng-click="vm.addUser()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> User konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true">
          <usereditor user="vm.user"></usereditor>
        </div>
        
        
      `,
            controllerAs: 'vm',
            controller: ['$log', 'User', 'UserHelper',
                function ($log, User, UserHelper) {
                    let vm = this;
                    vm.save = save;
                    vm.showuser = showuser;

                    vm.getUsers = getUsers;
                    // vm.addUser = UserHelper.addUser;
                    vm.addUser = addUser;
                    vm.editUser = UserHelper.editUser;

                    vm.$onInit = function () {
                        vm.newuser = {};

                        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
                            vm.editinplace = true;
                        }

                        $log.debug('debug - editinplace', vm.editinplace);


                        if (angular.isUndefined(vm.ti)) {
                            vm.ti = 0;
                            vm.tabi = 0;
                        }
                        if (angular.isString(vm.ti)) {
                            vm.tabi = parseInt(vm.ti, 10);
                        }
                        else {
                            vm.tabi = 0;
                        }
                        vm.lastuser = angular.copy(vm.userresult);
                        vm.lastuserref = angular.copy(vm.userref);
                    };

                    function addUser() {
                        $log.debug('debug - usersearch addUser called');
                        UserHelper.addUser(function (user) {
                            $log.debug('debug: handle newly create user');
                            vm.user = {};
                            vm.user.username = user.username;
                            vm.user.realName = user.realName;
                            vm.user._id = user._id;
                            vm.userref = user._id;
                            vm.user.email = user.email;
                            vm.user.tel = user.tel;
                            vm.asyncSelected = user.short;
                            vm.parentsave({user: vm.user, userref: vm.userref});
                        }, function (err) {
                            vm.error = true;
                            $log.error(err);
                        });
                    }


                    // typeahead user search backend query
                    function getUsers(val) {
                        return User.$searchahead({
                            query: val,
                            fields: ['username', 'realName', 'email', 'tel']
                        }).$asPromise().then(function (response) {
                            return response.map(function (user) {
                                user.text = user.username+ ', ';
                                if(user.realName != null)
                                    user.text += user.realName+': ';
                                if(user.email != null)
                                    user.text += user.email +', ';
                                if(user.tel != null)
                                    user.text += user.tel;
                                delete vm.error;
                                return user;
                            });
                        });
                    }

                    // typeahead user search action
                    function showuser($item, $model, $label) {
                        /* jshint unused:false */
                        /* eslint "no-unused-lets": [2, {"args": "none"}] */
                        vm.user = $model;
                        vm.userref = $model._id;
                        delete vm.asyncSelected;
                        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
                            vm.editinplace = true;
                        }
                        $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
                        if (vm.editinplace === true) {
                            vm.user = $model;
                            vm.userref = $model._id;
                            $log.debug('debug - usersearch editinplace');
                        }
                        else {
                            vm.user = {};
                            vm.user.username = $model.username;
                            vm.user.realName = $model.realName;
                            vm.user._id = $model._id;
                            vm.userref = $model._id;
                            vm.user.email = $model.email;
                            vm.user.tel = $model.tel;
                            vm.parentsave({user: vm.user, userref: vm.userref});
                            $log.debug('debug - usersearch do not  editinplace', vm.parentsave);
                        }
                    }

                    function save() {
                        if (!angular.equals(vm.user, vm.lastuser) || !angular.equals(vm.userref, vm.lastuserref)) {
                            vm.lastuser = angular.copy(vm.user);
                            vm.lastuserref = angular.copy(vm.userref);
                            vm.parentsave({user: vm.user, userref: vm.userref});
                        }
                    }


                }] // controller
        }); // component

// klammerfriedhof
}());